import { useQuery } from "react-query";
import apiService from "services/api";

export const queryKeys = {
	ALL_COURSES: ["course", "all"],
	STAFF_COURSES: ["staff", "course"],
};
export const useCourseQuery = () => useQuery(["course", "all"], () => apiService.course.get());
export const useCourseConfidenceQuery = () => useQuery(["staff", "course"], () => apiService.staff.courseConfidence.get());
export const useLessonQuery = () => useQuery(["lesson", "all"], () => apiService);
